// 通用项埋点
const _globalMixSortFilter = {
  stock_sort: 'stock_sort', // 点击库存排序
  all_stock: 'all_stock', // 切换总库存
  gd_stock: 'gd_stock', // 切换广东仓
  js_stock: 'js_stock', // 切换江苏仓
  filter_pdf: 'filter_pdf', // 数据手册
  search_in_result: 'search_in_result', // 二次筛选触发
  global_brand: 'global_brand', // 国际品牌
  CN_brand: 'CN_brand', // 国产品牌
  discount_commodity: 'discount_commodity', // 折扣
  sales: 'sales', // 销量
  spot_commodity: 'spot_commodity', // 现货
  comprehensive_sort: 'comprehensive_sort', // 综合排序
  price: 'price', // 价格
};

// 备货找料埋点
const _globalFindAndStock = {
  stock_find: 'stock_find', // 备货找料
  free_stock: 'free_stock', // tab免费备货
  quick_find: 'quick_find', // tab快速找料
  change_batch: 'change_batch', // 换一批
  find_price: 'find_price', // 星级询价
  SO_GO_STOCK_PAGE: 'SO_GO_STOCK_PAGE', // 按钮我要备货
  SO_GO_FIND_PAGE: 'SO_GO_FIND_PAGE', // 按钮我要找料
  PCB_SMT: 'PCB_SMT', // SMT图片入口
  SO_GO_HOT_MATERIAL: 'SO_GO_HOT_MATERIAL', // 点击热门找料
  go_find_page: 'go_find_page', // 找不到匹配商品页 点击我要找料
};

const _globalEmptyResult = {
  go_find_page: 'go_find_page',
  connect_service: 'connect_service',
};

// 价格库存筛选
const _globalPriceAndStock = {
  apply_filter: 'apply_filter', // 应用筛选
};

// 复制文本埋点
const _globalCopyText = {
  型号: 'copy_model',
  品牌: 'copy_brand',
  封装: 'copy_fengzhuang',
  类目: 'copy_catalog',
  参数: 'copy_param',
  描述: 'copy_miaoshu',
  编号: 'copy_code',
};

export { _globalMixSortFilter, _globalFindAndStock, _globalPriceAndStock, _globalEmptyResult, _globalCopyText };
